var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-list',{attrs:{"columns":_vm.columns,"dataSource":_vm.dataSource,"showHeader":_vm.showHeader,"height":"notset"}})
}
var staticRenderFns = []

export { render, staticRenderFns }